import { ChipSize } from './types';
import { TypographyVariant } from '../../tokens/typography.css';

export const chipTextSize = (size: ChipSize): TypographyVariant => {
  switch (size) {
    case 'xs':
      return '13_400';
    case 's':
      return '13_400';
    case 'm':
      return '14_400';
    case 'l':
      return '16_400';
    case 'xl':
      return '16_400';
  }
};

export const chipSelectedTextSize = (size: ChipSize): TypographyVariant => {
  switch (size) {
    case 'xs':
      return '13_500';
    case 's':
      return '13_500';
    case 'm':
      return '14_500';
    case 'l':
      return '16_500';
    case 'xl':
      return '16_500';
  }
};
